import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { trackInternalEvent } from '@rio/tracking'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'

import { InfoBox, SuccessBox } from '../..'
import { WidgetProps } from '../../widget.types'
import { WidgetTheme } from '../../WidgetTheme'
import { ActionButton, WidgetBox, WidgetContainer } from '../../widget.styles'

import { useThemeConfig } from '../../hooks/useThemeConfig'
import { useChangeCareersConfig } from './hooks/useChangeCareersConfig'

import { ActionButtons } from './ActionButtons'
import ChangeCareersImage from './assets/ilustration.png'
import ChangeCareersMobileImage from './assets/ilustration-mobile.png'
import * as Styles from './styles'

export const ChangeCareers = ({ service }: WidgetProps) => {
  const { isPhone } = useMediaQueries()
  const theme = useThemeConfig({ service })
  const { text, status, steps } = useChangeCareersConfig(service)

  const isCompleted = status === 'completed'
  const src = isPhone ? ChangeCareersMobileImage : ChangeCareersImage

  useEffect(() => {
    if (isCompleted) {
      trackInternalEvent('progress_score_completed', { score: service.title })
    }
  }, [isCompleted, service.title])

  return (
    <WidgetTheme theme={theme[status]} tipOrder={2}>
      <WidgetContainer>
        <WidgetBox>
          <InfoBox text={text} isCompleted={isCompleted}>
            {isCompleted ? (
              <ActionButton as={Link} to={service.getNextActionUrl()}>
                {text.actionText}
              </ActionButton>
            ) : (
              <ActionButtons steps={steps} text={text} service={service} />
            )}
          </InfoBox>
        </WidgetBox>
        <WidgetBox>{isCompleted ? <SuccessBox /> : <Styles.Image src={src} />}</WidgetBox>
      </WidgetContainer>
    </WidgetTheme>
  )
}
